import { useEffect, useState } from 'react';
import Header from '../../common/Header/Header';
import {
  Page,
  TableWrapper,
  Buttons,
  ButtonsSeparator,
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Button from '../../components/Button/Button';
import { Variant } from '../../components/Button/Button.types';
import Table from '../../components/Table/Table';
import { SelectionChangedEvent } from 'ag-grid-community';
import { useNavigate } from 'react-router-dom';
import Modal from '../../components/Modal/Modal';
import { StyledButtons } from './ComboTopping.styles';
import { useComboTopping, useRemoveComboTopping } from '../../services/comboTopping/comboTopping.service';
import { showToast } from '../../components/Toast/Toast';
import { genericErrorShowToastOptions } from '../../utils/useGenericErrorMessage/useGenericErrorMessage';
import { ToastTypes } from '../../components/Toast/Toast.types';
import { ComboToppingItem, RemoveComboTopping } from '../../services/comboTopping/comboTopping.types';

const ComboTopping = () => {
  const navigate = useNavigate();
  const { data, isError, refetch } = useComboTopping(true);
  const comboToppings = data?.data;
  const { mutate: deleteComboTopping, error: deleteError } = useRemoveComboTopping();
  const [selectedComboTopping, setSelectedComboTopping] = useState<ComboToppingItem[]>([]);
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };
  const openModal = () => {
    setModalOpen(true);
  };

  const onSelectionChanged = (event: SelectionChangedEvent) => {
    setSelectedComboTopping(event.api.getSelectedRows());
  };

  useEffect(() => {
    if (isError)
      showToast({
        ...genericErrorShowToastOptions,
        label: 'Error fetching combo toppings.',
        id: 'errorFetchingComboTopping',
        toastType: ToastTypes.Error,
      });
  }, [isError]);

  useEffect(() => {
    if (deleteError)
      showToast({
        ...genericErrorShowToastOptions,
        label: 'Error deleting combo toppings.',
        id: 'errorDeletingComboTopping',
        toastType: ToastTypes.Error,
      });
  }, [deleteError]);


  const onRemoveRow = () => {
    if (selectedComboTopping.length > 0) {
      const comboToppingsToDelete: RemoveComboTopping[] = selectedComboTopping.map(item => ({
        mmsClassNo: item.mmsClassNo,
        mmsClassDescription: item.mmsClassDescription,
        mmsProdNo: item.mmsProdNo,
        mmsProdDescription: item.mmsProdDescription,
        mmsOptionNo: item.mmsOptionNo,
        mmsOptionDescription: item.mmsOptionDescription
      }));
  
      deleteComboTopping(comboToppingsToDelete, {
        onSuccess: () => {
          showToast({
            label: 'Combo Toppings Deleted',
            id: 'comboToppingDeleteSuccess',
          });
          closeModal();
          refetch();
          setSelectedComboTopping([]);
        },
      });
    } else {
      showToast({
        label: 'No Combo Toppings selected',
        id: 'noComboToppingSelectedError',
        toastType: ToastTypes.Error,
      });
    }
  };
  

  return (
    <>
      <Header
        titleTestId='ComboToppingTitle'
        breadcrumb={{ to: '/tables', label: 'All tables' }}
        title='Combo Topping'
      />
      <Page>
        <TableWrapper>
          <Table
            onSelectionChanged={onSelectionChanged}
            returnedRecords={comboToppings?.length || 0}
            rowData={comboToppings}
            height={'100%'}
            rowSelection={'multiple'}
            suppressRowClickSelection={false}
            rowMultiSelectWithClick={true}
            columnDefs={[
              {
                minWidth: 48,
                field: '',
                maxWidth: 70,
                headerName: 'Select',
                checkboxSelection: true,
                floatingFilter: false,
                sortable: false,
              },
              { minWidth: 112, field: 'mmsClassNo', headerName: 'MMS Class No.' },
              { minWidth: 112, field: 'mmsClassDescription', headerName: 'MMS Class Desciption' },
              { minWidth: 112, field: 'mmsProdNo', headerName: 'MMS Prod No.' },
              { minWidth: 112, field: 'mmsProdDescription', headerName: 'MMS Prod Description' },
              { minWidth: 112, field: 'mmsOptionNo', headerName: 'MMS Option No.' },
              { minWidth: 112, field: 'mmsOptionDescription', headerName: 'MMS Option Description' },
            ]}
          />
        </TableWrapper>
        <Buttons>
          <Button
            label='Add New'
            variant={Variant.Primary}
            testId='AddComboToppingButton'
            onClick={() => navigate(`/tables/combotopping/addnewcombotopping`)}
          />
          <Button
            label='Delete'
            variant={Variant.Secondary}
            testId='DeleteComboToppingButton'
            onClick={openModal}
            disabled={selectedComboTopping.length === 0}
          />

          <ButtonsSeparator />
        </Buttons>
        <Modal id='removeComboToppingModal' open={modalOpen} onClose={closeModal} title='Remove Combo Topping'>
          <div>
            <Table
            height={'400px'}
            rowData={selectedComboTopping}
            returnedRecords={selectedComboTopping?.length}
              columnDefs={[
                {
                  minWidth: 48,
                  field: '',
                  maxWidth: 70,
                  headerName: 'Select',
                  checkboxSelection: false,
                  sortable: false,
                },
                { minWidth: 112, field: 'mmsClassNo', headerName: 'MMS Class No.' },
                { minWidth: 112, field: 'mmsClassDescription', headerName: 'MMS Class Desciption' },
                { minWidth: 112, field: 'mmsProdNo', headerName: 'MMS Prod No.' },
                { minWidth: 112, field: 'mmsProdDescription', headerName: 'MMS Prod Description' },
                { minWidth: 112, field: 'mmsOptionNo', headerName: 'MMS Option No.' },
                { minWidth: 112, field: 'mmsOptionDescription', headerName: 'MMS Option Description' },
              ]}
            />
            <StyledButtons>
              <Button label='Cancel' testId='closeModalButton' onClick={closeModal} variant={Variant.Secondary} />
              <Button
                label='Delete'
                testId='deleteComboToppingModalButton'
                onClick={onRemoveRow}
                variant={Variant.Primary}
              />
            </StyledButtons>
          </div>
        </Modal>
      </Page>
    </>
  );
};

export default ComboTopping;
